import type { ReactNode } from 'react';

import { generatedTextAttrs } from './debrief.ts';

/**
 * What the debrief model wrote, in the language it wrote it in. Its English
 * quotations are left to the bidi algorithm, which keeps a Latin run whole
 * inside Arabic; wrapping each would mean parsing the model's quotes.
 */
export function GeneratedText({ language, children }: { language: string | null | undefined; children: ReactNode }) {
  const { lang, dir } = generatedTextAttrs(language);
  return (
    <span lang={lang} dir={dir}>
      {children}
    </span>
  );
}
